export default "__VITE_ASSET__371FngIB__"